import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import AppBar from "src/components/AppBar/AppBar";
import { IconName } from "src/components/Icon/Icon";
import { IRootState } from "src/store/reducers";
import { fetchAppCommentDetails, fetchAppCommentOptions, saveAppComment } from "src/store/reducers/applicationComments";
import * as S from "../../../../../constants/StringConstants";
import CommentInfo from "../CommentInfo/CommentInfo";
import CommentsForm from "../CommentsForm/CommentsForm";

const CommentsDetail = () => {
  const [newComment, setNewComment] = useState("");
  const { appId, id } = useParams<{ id: string; appId: string }>();
  const dispatch = useDispatch();
  const history = useHistory();
  const isNew = id === "new";

  const { userID, appCommentDetails, isFetching } = useSelector((state: IRootState) => ({
    userID: state.auth.user.userID,
    isFetching: state.applicationComments.loading,
    appCommentDetails: state.applicationComments.commentDetails,
  }));

  useEffect(() => {
    if (isNew) {
      dispatch(fetchAppCommentOptions());
    } else {
      dispatch(fetchAppCommentDetails(id));
    }
  }, [dispatch, id, isNew]);

  const initialValues = {
    id: appCommentDetails?.id,
    dueDate: appCommentDetails?.dueDate,
    followUpDate: appCommentDetails?.followUpDate,
    confidentialFlag: appCommentDetails?.confidentialFlag,
    reoccurFlag: appCommentDetails?.reoccurFlag,
    description: appCommentDetails?.description,
    commentPriorityID: get(appCommentDetails, "commentPriorityID"),
  };

  const handleSubmit = async (values: any) => {
    const payload = {
      ...values,
      comment: newComment.trim() ? newComment : undefined,
    };

    try {
      await dispatch(saveAppComment(appId, userID, payload));
      setNewComment("");
      history.push(`/applications/${appId}/comments`);
    } catch (error) {
      alert(`Error: ${error}`);
    }
  };

  return (
    <div className="comments-detail">
      <AppBar icon={IconName.Applications} title={S.APP_COMMENTS_DETAIL_TITLE} loading={isFetching} />

      {!isFetching && (
        <div className="comments-detail__inner-container">
          <CommentInfo commentDetails={appCommentDetails} />
          <hr />

          <Form
            initialValues={initialValues}
            onSubmit={handleSubmit}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <CommentsForm
                  commentDetails={appCommentDetails}
                  newComment={newComment}
                  setNewComment={setNewComment}
                />

                <div className="app-builder__action_buttons">
                  <button type="button" className="button-v2 button-v2__secondary" onClick={() => history.goBack()}>
                    Cancel
                  </button>
                  <button type="submit" className="button-v2 button-v2__primary">
                    Save And Close
                  </button>
                </div>
              </form>
            )}
          />
        </div>
      )}
    </div>
  );
};

export default CommentsDetail;
